export default function ({ redirect, route, store }) {
  if (
    !store.getters["user/IS_BAND"] ||
    !route.query.errorCode ||
    !route.query.origin
  )
    return redirect("/")
}
